import React, { PropTypes, Component } from 'react';
import { Field } from 'redux-form';
import { Link } from 'react-router';
import { SimpleTextInputField } from 'common/components/form_fields';
import Support from 'marketing/containers/support';
import { v4 } from 'node-uuid';
import Attribute from 'marketing/common/attribute';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import IntercomChat from 'common/containers/intercom_chat';
import partial from 'lodash/partial';
import {
  trackMixpanel, trackClickWithMixpanel,
  MP_VIEWED_MARKETING_PAGE_EVENT_NAME, MP_CLICKED_DESIGN_CONSULTATION_EVENT_NAME
} from 'common/tracking';

class PricingCategory extends Component {

  componentDidMount() {
    trackMixpanel(
      MP_VIEWED_MARKETING_PAGE_EVENT_NAME,
      {
        "pageName": "Categories"
      }
    )
  }

  componentWillMount() {
    this.props.fetchCategoriesIfNeeded();
  }

  render() {
    const { matchedCategories } = this.props;
    return (<div className="l-content" id="content">
      <Meta
        title="Graphic Design, Product Design, and Business Naming Services"
        meta={[
          { name: 'robots', content: 'index,follow' },
          { name: 'description', content: 'From logos to websites, to packaging and product design, and more. Perfect for clients of any size. Affordable and risk-free, with our 100% money-back guarantee!' },
          { name: 'keywords', content: 'crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing' }
        ]}
        link={[{ rel: 'canonical', href: getCanonicalURL('/categories/') }]}
      />
      <section className="block block-hero hero-1">
        <div className="row">
          <div className="columns small-16 medium-11 large-8">
            <div className="hero-container">
              <h1 className="hero-title">Whatever you need, we&apos;ve&nbsp;got&nbsp;it.</h1>
              <h3 className="hero-subtitle">
                We have nearly 40 categories to handle your creative needs but,
                if you can’t find&nbsp;something that fits, talk&nbsp;to one&nbsp;of&nbsp;our&nbsp;experts.
              </h3>
              <div className="hero-actions">
                <Link to="/help/contact/consultation/" className="btn btn-text">
                  <span onClick={partial(trackClickWithMixpanel, MP_CLICKED_DESIGN_CONSULTATION_EVENT_NAME, {pageName: "Categories", version: "english", pageArea: "Hero"}) }>
                    Free Design Consultation <i className="fa fa-long-arrow-right" />
                  </span>
                </Link>
              </div>
            </div>
          </div>
          <div className="columns small-16 medium-5 large-8">
            <div className="artwork-container">
              <img
                alt="State Trooper Stache Wax by badaboom"
                className="hero-art"
                src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_categories_hero-1_stache-wax.png"
              />
              <Attribute to="badaboom" text="awarded entry by" />
            </div>
          </div>
        </div>
      </section>
      <section className="block thick block-categories-list">
        <div className="row">
          <div className="columns small-16 medium-12">
            <form className="categories">
              <label htmlFor="category">I need a(n)</label>
              <Field
                id="category"
                component={SimpleTextInputField}
                name="category"
                placeholder="Logo, website, name..."
              />
            </form>
          </div>
        </div>
        <div className="row columns">
          <div className="popular-indicator">
            <i className="fa fa-flash" /> Popular
          </div>
          {matchedCategories.length === 0 && <div key={v4()} className="row category">
            <h2 className="small-16 columns">1-to-1</h2>
            <div className="small-16 medium-8 large-6 columns">
              <Link to="/1to1-projects/"><h3>1-to-1 Design</h3></Link>
            </div>
          </div>}
          {matchedCategories.length === 0 && <div key={v4()} className="row category">
            <h2 className="small-16 columns">Design Consultation</h2>
            <div className="small-16 medium-8 large-6 columns">
              <Link to="/help/contact/consultation/"><h3>Free Design Consultation</h3></Link>
            </div>
          </div>}
          {matchedCategories.map(cat => (
            <div key={v4()} className="row category">
              <h2 className="small-16 columns">{cat.name}</h2>
              {cat.sub_categories && cat.sub_categories.map(subcat => (<div key={v4()} className="small-16 medium-8 large-6 columns subcategory">
                {subcat.is_popular && <i className="fa fa-flash popular" />}
                {subcat.is_popular && ' '}
                <Link to={`/${subcat.slug}/`}><h3>{subcat.name}</h3></Link>
                </div>
              ))}
            </div>
          ))}
        </div>
      </section>
      <Support
        consultationEventTracking={{
          eventName: MP_CLICKED_DESIGN_CONSULTATION_EVENT_NAME,
          eventData: {
            pageName: "Categories",
            version: "english",
            pageArea: "Support footer",
          }
        }}
      />
      <IntercomChat />
    </div>);
  }
}

PricingCategory.propTypes = {
  matchedCategories: PropTypes.array,
  fetchCategoriesIfNeeded: PropTypes.func.isRequired,
};

export default PricingCategory;



// WEBPACK FOOTER //
// ./marketing/components/categories.jsx